const WHO_WE_ARE = {};

const CUSTOMER_CARE = {
  leftNav: {
    title: "Customer Care",
    navListItems: [
      { text: "Warranty Guidelines", url: "WARRANTY_GUIDELINES" },
      { text: "Payment Options", url: "PAYMENT_OPTIONS" },
      { text: "Shipping Info", url: "SHIPPING_INFO" },
      { text: "Returns and Exchanges", url: "RETURNS_AND_EXCHANGES" },
      { text: "Order Status", url: "ORDER_STATUS" },
      { text: "Wrong or Damaged Order", url: "WRONG_OR_DAMAGED_ORDER" },
    ],
    mobileLeftNav: {
      title: "Browse :",
    },
  },
  mobileLeftNav: {
    title: "Browse :",
    navListItems: [
      "Warranty Guidelines",
      "Payment Options",
      "Shipping Info",
      "Returns and Exchanges",
      "Order Status",
      "Wrong or Damaged Order",
    ],
  },
};
export { WHO_WE_ARE, CUSTOMER_CARE };
